import { render, staticRenderFns } from "./NameOwnerSearchResult.vue?vue&type=template&id=77356baf&scoped=true"
import script from "./NameOwnerSearchResult.vue?vue&type=script&lang=js"
export * from "./NameOwnerSearchResult.vue?vue&type=script&lang=js"
import style0 from "./NameOwnerSearchResult.vue?vue&type=style&index=0&id=77356baf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77356baf",
  null
  
)

export default component.exports